/* eslint-disable @typescript-eslint/no-explicit-any */
import { B2B_VIEW_BIG_RECEIPT_PATH, OMS_ADD_RECEIPT_PATH, OMS_ORDER_DETAILS_PATH, OMS_BUY_IT_AGAIN_PATH, OMS_EDIT_JOB_NAME_PATH, OMS_EXPORT_HISTORY_TO_QUICKBOOKS_PATH, OMS_LOCKER_CODE_PATH, OMS_ORDER_HISTORY_PATH, OMS_PH_OFFLINE_DOWNLOAD_PATH, OMS_QUICKBOOKS_LOGIN_PATH, OMS_QUICKBOOKS_ORDERS_COUNT_PATH, OMS_QUICKBOOKS_SYNC_PATH, OMS_TOTAL_SPEND_PATH, OMS_VIEW_RECEIPT_PATH, PRINT_PURCHASE_HISTORY_PATH, OMS_ORDER_HISTORY_LOCAL_DELIVERY, CPS_ITEM_LEVEL_SEARCH_PATH, } from '../../constants/paths';
import { apiB2B, apiB2BWithBlob, apiB2C, apiBase } from '../axios-client';
import { getXClientApp } from '../../utils/channel-helpers';
// 🚨 Will fix after merge
// eslint-disable-next-line prettier/prettier
export var GetLocalDeliveriesAPI = function (requestData) {
    return apiB2B.post(OMS_ORDER_HISTORY_LOCAL_DELIVERY, requestData);
};
export var GetOrderHistoryAPI = function (requestData, channel) {
    // Always send channel headers since we can't predict if backend will use CPS or LSS
    if (requestData.orderHistoryRequest.searchType) {
        return apiB2B.post(OMS_ORDER_HISTORY_PATH, requestData, {
            headers: {
                channel: channel,
                'X-Client-App': getXClientApp(channel),
            },
        });
    }
    return apiB2C.post(OMS_ORDER_HISTORY_PATH, requestData, {
        headers: {
            channel: channel,
            'X-Client-App': getXClientApp(channel),
        },
    });
};
export var AddOnlineReceipt = function (requestData) {
    var customerAccountId = requestData.customerAccountId, onlineReceipts = requestData.onlineReceipts;
    if (!onlineReceipts || onlineReceipts.length === 0) {
        throw new Error('onlineReceipts is undefined or empty');
    }
    var _a = onlineReceipts[0], emailId = _a.emailId, salesDate = _a.orderDate, orderNumber = _a.orderNumber;
    var request = {
        customerAccountId: customerAccountId,
        receiptType: 'ONLINE',
        emailId: emailId,
        salesDate: salesDate,
        orderNumber: orderNumber,
    };
    return AddReceipt(request);
};
export var AddInstoreReceipt = function (requestData) {
    var customerAccountId = requestData.customerAccountId, storeReceipts = requestData.storeReceipts;
    if (!storeReceipts || storeReceipts.length === 0) {
        throw new Error('storeReceipts is undefined or empty');
    }
    var _a = storeReceipts[0], preTaxAmount = _a.preTaxAmount, registerNumber = _a.registerNumber, salesDate = _a.saleDate, storeNumber = _a.storeNumber, transactionId = _a.transactionId;
    var request = {
        customerAccountId: customerAccountId,
        receiptType: 'STORE',
        preTaxAmount: preTaxAmount,
        registerNumber: registerNumber,
        salesDate: salesDate,
        storeNumber: storeNumber,
        transactionId: transactionId,
    };
    return AddReceipt(request);
};
export var AddReceipt = function (requestData) {
    return apiB2B.post(OMS_ADD_RECEIPT_PATH, requestData);
};
/**
 * Not a OMS api but is only assoicated with Order History in b2b fed,so will reside here
 * until we decided a better place or api moves to oms.
 */
export var ViewBigReceipt = function (receiptRequest) {
    return apiB2BWithBlob.post(B2B_VIEW_BIG_RECEIPT_PATH, receiptRequest);
};
export var GetOrderDetailsAPI = function (requestData, customerType, customerRole) {
    if (customerType === 'b2b' ||
        (customerType === 'b2x' && customerRole !== '')) {
        return apiB2B.post(OMS_ORDER_DETAILS_PATH, requestData);
    }
    return apiB2C.post(OMS_ORDER_DETAILS_PATH, requestData);
};
// Export
export var ExportPurchaseHistory = function (request) {
    return apiB2BWithBlob.post("".concat(OMS_ORDER_HISTORY_PATH, "/export"), request);
};
export var PurchaseHistoryOfflineDownload = function (request) {
    return apiBase.post(OMS_PH_OFFLINE_DOWNLOAD_PATH, request);
};
// Quick Books
export var qbCountAPI = function (request) {
    return apiB2B.post(OMS_QUICKBOOKS_ORDERS_COUNT_PATH, request);
};
export var quickbooksLogin = function (request) {
    return apiB2B.post(OMS_QUICKBOOKS_LOGIN_PATH, request);
};
export var quickbooksDesktopExport = function (request) {
    return apiBase.post(OMS_EXPORT_HISTORY_TO_QUICKBOOKS_PATH, request);
};
export var quickbooksSync = function (request, authCode) {
    return apiB2B.post(OMS_QUICKBOOKS_SYNC_PATH, request, {
        headers: { QB_Authorization: authCode },
    });
};
export var quickbooksOAuth = function (request) {
    return apiBase.post(OMS_EXPORT_HISTORY_TO_QUICKBOOKS_PATH, request);
};
// Buy It Again
export var BuyItAgainAPI = function (request) {
    return apiB2B.post(OMS_BUY_IT_AGAIN_PATH, request);
};
export var printPurchaseHistory = function (request) {
    return apiB2BWithBlob.post(PRINT_PURCHASE_HISTORY_PATH, request);
};
export var editPOJobName = function (request) {
    return apiB2B.post(OMS_EDIT_JOB_NAME_PATH, request);
};
export var getViewReceipt = function (request) {
    return apiB2B.post(OMS_VIEW_RECEIPT_PATH, request);
};
// Total Spend
export var getTotalSpend = function (request) {
    return apiB2B.post(OMS_TOTAL_SPEND_PATH, request);
};
// Locker Code
export var getLockerCode = function (request, customerType, cookie) {
    if (customerType === 'b2b' || customerType === 'b2x') {
        return apiB2B.post(OMS_LOCKER_CODE_PATH, request, {
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json',
                Cookie: cookie,
            },
        });
    }
    return apiB2C.post(OMS_LOCKER_CODE_PATH, request, {
        headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            Cookie: cookie,
        },
    });
};
// CPS Search
export var getCPSItemLevelSearch = function (request, channel) {
    return apiB2B.post(CPS_ITEM_LEVEL_SEARCH_PATH, request, {
        headers: {
            channel: channel,
            'X-Client-App': getXClientApp(channel),
        },
    });
};
